/**
 * Warm Transfer Slice - Manages warm transfer context and state
 *
 * Tracks the two-call relationship during attended transfer:
 * - Original call (on hold)
 * - Consultation call (active with recipient)
 * - Transfer state progression (initiating → consulting → completing → completed)
 */

import type { WarmTransferSlice, WarmTransferSliceState } from './index.types';
import type { SoftphoneStore } from 'Modules/softphone/store';
import type { StateCreator } from 'zustand';

export * from './index.types';

const initialState: WarmTransferSliceState = {
  warmTransferContext: null,
  isCompletingTransfer: false,
};

export const createWarmTransferSlice: StateCreator<
  SoftphoneStore,
  [],
  [],
  WarmTransferSlice
> = (set) => ({
  ...initialState,

  setWarmTransferContext: (context) => set({ warmTransferContext: context }),

  updateWarmTransferContext: (updates) =>
    set((state) => {
      if (!state.warmTransferContext) {
        return state;
      }

      return {
        warmTransferContext: { ...state.warmTransferContext, ...updates },
      };
    }),

  clearWarmTransferContext: () =>
    set({ warmTransferContext: null, isCompletingTransfer: false }),

  setIsCompletingTransfer: (value) => set({ isCompletingTransfer: value }),
});
